module.exports = __webpack_public_path__ + "static/img/banada.00b8eac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/beads/banada.jpg
// module id = 52
// module chunks = 1